import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';
import { Button } from '@/fsd/shared/ui';
import { Checkbox } from '@/fsd/shared/ui/checkbox/checkbox';
import Modal from '@/fsd/shared/ui/Modal/Modal';
import { useMutation } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { accountCabinetOnboardingDismiss } from '../../api/accountCabinetOnboardingDismiss/accountCabinetOnboardingDismiss';
import { accountCabinetOnboardingStart } from '../../api/accountCabinetOnboardingStart/accountCabinetOnboardingStart';
import { useGetOnboardingState } from '../../model/hooks/useGetOnboardingState';
import { onboardingStore } from '../../model/store/onboardingStore';
import { OnboardingTooltip } from '../onboardingTooltip/onboardingTooltip';
import styles from './settingOnboardingTooltip.module.scss';

export const SettingOnboardingTooltip = observer(() => {
  const navigate = useNavigate();

  const [checked, setChecked] = useState(false);

  const { isOnboardingStateSuccess, onboardingState } = useGetOnboardingState();

  const { mutateAsync: accountCabinetOnboardingDismissMutate } = useMutation({
    mutationFn: accountCabinetOnboardingDismiss,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['onboarding-state'] }),
  });

  const {
    mutateAsync: accountCabinetOnboardingStartMutate,
    isPending: isAccountCabinetOnboardingStartMutatePending,
  } = useMutation({
    mutationFn: accountCabinetOnboardingStart,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['onboarding-state'] }),
  });

  useEffect(() => {
    onboardingStore.setNavigate(navigate);
    onboardingStore.initStore();
  }, []);

  const onCheckedChange = async () => {
    const checkedData = checked;

    try {
      if (checkedData) {
        setChecked(false);
        await accountCabinetOnboardingStartMutate();
      } else {
        setChecked(true);
        await accountCabinetOnboardingDismissMutate();
      }
    } catch (e) {
      if (checkedData) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  };

  return (
    <>
      <Modal
        title="Добро пожаловать в Busyboard!"
        height="fit-content"
        size="small"
        showModal={onboardingStore.show}
        setShowModal={onboardingStore.setShow}
        className={styles.modal}
        footer={
          <div className={styles.footer}>
            <Checkbox
              onChange={onCheckedChange}
              checked={checked}
              label="Больше не показывать"
              className={styles.checkbox}
            />
            <div className={styles.buttonsGroup}>
              <Button
                variant="outline"
                size="l"
                onClick={async () => {
                  onboardingStore.setShow(false);
                }}
              >
                Закрыть
              </Button>
              <Button
                size="l"
                onClick={async () => {
                  // if (
                  //   onboardingState?.active === false ||
                  //   onboardingState?.status === 'not_started'
                  // ) {
                  //   await accountCabinetOnboardingStartMutate();
                  // }

                  onboardingStore.startTour();
                }}
                disabled={isAccountCabinetOnboardingStartMutatePending}
              >
                Запуск
              </Button>
            </div>
          </div>
        }
      >
        <div className={styles.content}>
          <p>
            Busyboard поможет увидеть реальную прибыль вашего бизнеса на
            маркетплейсах — без ручных таблиц и догадок.
          </p>
          <p>
            Чтобы всё заработало, нужно настроить несколько ключевых вещей:
            подключить API кабинетов и банков, создать склады и контрагентов,
            загрузить начальные остатки и задать базовые параметры учёта и
            налогообложения.
          </p>
          <p>Это займёт около 30 минут.</p>
        </div>
      </Modal>
      {isOnboardingStateSuccess && (
        <OnboardingTooltip
          onEvent={async (data) => {
            if (
              data.action === 'close' ||
              data.action === 'closed' ||
              data.status === 'finished' ||
              data.status === 'skipped' ||
              data.status === 'paused'
            ) {
              onboardingStore.stopTour();
            }
          }}
        />
      )}
    </>
  );
});
